import Marquee from "react-fast-marquee";

const PHRASES = ["1 minuut langer rijden.", "Iedere dag meer rust.", "Samen voor 80 km/u"];

export const EditorialMarquee = () => (
  <div
    data-testid="editorial-marquee"
    aria-hidden="true"
    className="mt-20 border-y border-gooi-green/10 py-6 md:mt-28"
  >
    <Marquee speed={28} gradient={false} pauseOnHover={false}>
      {PHRASES.concat(PHRASES).map((p, i) => (
        <span
          key={i}
          className="mx-8 font-display text-2xl font-medium tracking-tight text-gooi-green/15 md:text-4xl"
        >
          {p}
          <span className="mx-8 text-gooi-red/30">•</span>
        </span>
      ))}
    </Marquee>
  </div>
);
